import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { doPost } from "../../../config/fetchWrapper";
import { urls } from "../../endPoints";

export const LoginAction = createAsyncThunk("login",
    async (arg, { rejectWithValue }) => {
        try {
            const response = await doPost(urls?.login, arg);
            return response;
        } catch (error) {
            return rejectWithValue(error)
        }
    })

const LoginSlice = createSlice({
    name: "login",
    initialState: {
        isLoading: false,
        login: {},
        error: null
    },
    reducers: {
        LoginReset: () => {
            return {
                isLoading: false,
                login: false,
                error: null,
                success: false,
            };
        },
    },
    extraReducers: {
        [LoginAction.pending]: (state) => {
            state.isLoading = true;
            state.error = null;
        },
        [LoginAction.fulfilled]: (state, { payload }) => {
            state.isLoading = false;
            state.login = payload;
            state.error = null;
        },
        [LoginAction.rejected]: (state, { payload }) => {
            state.isLoading = false;
            state.error = payload;
        },
    }
})

export const { LoginReset } = LoginSlice.actions
export default LoginSlice.reducer;